import type { MobileGroupCardRendererProps, RenderCellOptions } from '@talos/kyoko';
import type { ReactNode } from 'react';

export const BALANCE_AMOUNT_COL_ID = 'Amount';
export const BALANCE_EQUIVALENT_AMOUNT_COL_ID = 'Equivalent.Amount';
export const BALANCE_AVAILABLE_AMOUNT_COL_ID = 'AvailableAmount';

const REQUIRED_BALANCE_METRIC_RENDER_OPTIONS = { overrideColumnVisibility: true } satisfies RenderCellOptions;

export interface BalanceMetric {
  colId: string;
  label: string;
  value: ReactNode;
  testId: string;
}

export function getRequiredBalanceMetrics(
  renderCell: MobileGroupCardRendererProps['renderCell'],
  homeCurrency: string
): BalanceMetric[] {
  return [
    {
      colId: BALANCE_AMOUNT_COL_ID,
      label: 'Quantity',
      value: renderCell(BALANCE_AMOUNT_COL_ID, REQUIRED_BALANCE_METRIC_RENDER_OPTIONS),
      testId: 'mobile-balance-card-quantity',
    },
    {
      colId: BALANCE_EQUIVALENT_AMOUNT_COL_ID,
      label: `${homeCurrency} Value`,
      value: renderCell(BALANCE_EQUIVALENT_AMOUNT_COL_ID, REQUIRED_BALANCE_METRIC_RENDER_OPTIONS),
      testId: 'mobile-balance-card-equivalent-amount',
    },
    {
      colId: BALANCE_AVAILABLE_AMOUNT_COL_ID,
      label: 'Available Amount',
      value: renderCell(BALANCE_AVAILABLE_AMOUNT_COL_ID, REQUIRED_BALANCE_METRIC_RENDER_OPTIONS),
      testId: 'mobile-balance-card-available-amount',
    },
  ];
}

export function getBalanceGroupValueMetric(
  renderCell: MobileGroupCardRendererProps['renderCell'],
  homeCurrency: string
): BalanceMetric {
  return {
    colId: BALANCE_EQUIVALENT_AMOUNT_COL_ID,
    label: `${homeCurrency} Value`,
    value: renderCell(BALANCE_EQUIVALENT_AMOUNT_COL_ID, REQUIRED_BALANCE_METRIC_RENDER_OPTIONS),
    testId: 'mobile-balance-group-card-equivalent-amount',
  };
}
